export const getEmailTemplateLink = (
  applicationCode: string,
  templateCode: string,
  isBlockBased?: boolean
) =>
  isBlockBased
    ? `https://app.pushwoosh.com/applications/${applicationCode}/email-templates/${templateCode}/edit-block`
    : `https://app.pushwoosh.com/applications/${applicationCode}/email-templates/edit/${Date.now()}/${templateCode}`;
